import axios from '~/utils/axiosInstance';
import type { ApiEvent } from '~/types/ApiEvent';

export interface IngestionUploadResponse {
  presignedUrl: string;
  s3Key: string;
  ingestionRequest: { id: string; projectId: string; s3Key: string; fileName: string; status: string };
}

export interface IngestionStartResponse {
  apiEvent: { id: string };
}

export interface IngestionHistoryEvent extends ApiEvent {
  fileName?: string | null;
}

export interface IngestionHistoryResponse {
  events: IngestionHistoryEvent[];
}

export async function getIngestionUploadUrl(
  projectId: string,
  fileName: string
): Promise<IngestionUploadResponse> {
  const response = await axios.post(`/projects/${projectId}/ingestion/upload`, { fileName });
  return response.data;
}

export async function startIngestion(
  projectId: string,
  params: {
    s3Key: string;
    fileName?: string;
    idempotencyKey?: string;
    additionalContext?: string;
  }
): Promise<IngestionStartResponse> {
  const response = await axios.post(`/projects/${projectId}/ingestion/start`, params);
  return response.data;
}

export async function getIngestionHistory(
  projectId: string
): Promise<IngestionHistoryResponse> {
  const response = await axios.get(`/projects/${projectId}/ingestion`);
  return response.data;
}
